import DemystLogo from "../../../assets/svg/DemystLogoWhite.svg";
import styles from "./PlatformDiagram.module.less";
import clsx from "clsx";

export const PlatformDiagram = () => {
  return (
    <div className={styles.Diagram}>
      <div className={clsx(styles.Aside, styles.AsideLeft)}>
        <div className={styles.AsideContent}>
          Any external data source, any frequency, any format
        </div>
      </div>
      <div className={clsx(styles.Line, styles.LineLeft)} />
      <div className={styles.Main}>
        <div className={styles.ArrowsOverlay}>
          <div />
          <div />
        </div>
        <div className={styles.Center}>
          <img alt="Demyst" src={DemystLogo.src} />
          <div className={styles.ButtonContainer}>
            <div className={styles.ButtonColumn}>
              <span className={styles.Tag}>Onboard</span>
              <span className={styles.Title}>Data and metadata</span>
              <span className={styles.Button}>Connectors</span>
            </div>
            <div className={styles.ButtonColumn}>
              <span className={styles.Tag}>Deploy</span>
              <span className={styles.Title}>Workflows</span>
              <span className={styles.Button}>Data APIs</span>
              <span className={styles.Button}>Data shares</span>
            </div>
            <div className={styles.TagBottom}>
              <span className={styles.Tag}>Maintain</span>
            </div>
          </div>
        </div>
        <div className={styles.List}>
          <div>
            <div className={styles.ListHeader}>Manage centrally</div>
            <ul>
              <li>Logs, monitoring and alerting</li>
              <li>Metadata management and data certification</li>
              <li>Platform security & compliance</li>
            </ul>
          </div>
        </div>
      </div>
      <div className={clsx(styles.Line, styles.LineRight)} />
      <div className={clsx(styles.Aside, styles.AsideRight)}>
        <div className={styles.AsideContent}>External data solutions</div>
      </div>
    </div>
  );
};
